<template>
  <div id="app">


    <nav class="navbar navbar-expand-lg bg-dark mb-3">
      <a class="navbar-brand" href="#">
        <img src="./assets/logo.png"> Calculator
      </a>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
        <div class="navbar-nav">
          <router-link class="nav-item nav-link" to="/live-ticker">Live Ticker</router-link>
          <router-link class="nav-item nav-link" to="/">Price History</router-link>
          <router-link class="nav-item nav-link" to="/production">Production Tree</router-link>
          <router-link class="nav-item nav-link" to="/company">Company</router-link>
          <router-link class="nav-item nav-link" to="/level">Level</router-link>
        </div>
      </div>
      <div class="player-data" v-if="player">{{ player.authUser.company }} - {{ player.authUser.money|toCurrency }}</div>
    </nav>
    <router-view/>
  </div>
</template>

<script>

  export default {
    computed: {
      player() {
        return this.$store.state.player.data;
      }
    },
    beforeMount() {
      if(this.$store.state.simsession!=null){
        fetch('https://sc.gamers-universe.eu/api/getPlayer.php?sessionid='+this.$store.state.simsession, {
          headers: {
            'Content-Type': 'application/json; charset=utf-8',
          },
        }).then(res => res.json()) // parse response as JSON (can be res.text() for plain response)
                .then(response => {
                  this.$store.commit('updatePlayer', response)
                }).catch(err => {
          console.log(err);
        });

        fetch('https://sc.gamers-universe.eu/api/getWarehouse.php?sessionid='+this.$store.state.simsession, {
          headers: {
            'Content-Type': 'application/json; charset=utf-8',
          },
        }).then(res => res.json()) // parse response as JSON (can be res.text() for plain response)
                .then(response => {

                  this.$store.commit('updateWarehouse', response)

                }).catch(err => {
          console.log(err);
        });
      }

      fetch('https://sc.gamers-universe.eu/api/getResources.php', {
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
        },
      }).then(res => res.json()) // parse response as JSON (can be res.text() for plain response)
              .then(response => {
                console.log(response);
                _.each(response, function(item,key) {
                  item.data = JSON.parse(item.data);
                })

                this.$store.commit('updateResources', response)
                console.log(this.resources);
              }).catch(err => {
        console.log(err);
      });
    }
  }

</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.navbar {
  padding: 30px;

  .navbar-brand {
    img {
      max-width: 40px;
    }
  }

  .player-data {
    color: #fff;
  }
  a {
    font-weight: bold;
    color: #fff;
    transition: all 0.4s;

    &.router-link-exact-active,&:hover {
      color: #42b983;
    }
  }
}
</style>
